/**
 * @generated SignedSource<<ceeb5ede123a93d0b2991a625a80a704>>
 * @relayHash 7f8c602e0df7c2a76a9c2f8ce24038fd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f8c602e0df7c2a76a9c2f8ce24038fd

import type { ConcreteRequest } from 'relay-runtime';
import type { Result } from "relay-runtime";
export type RepositoryMilestoneNewPageQuery$variables = {
  name: string;
  owner: string;
};
export type RepositoryMilestoneNewPageQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly nameWithOwner: string;
    readonly viewerCanPush: boolean;
  } | null | undefined, unknown>;
};
export type RepositoryMilestoneNewPageQuery = {
  response: RepositoryMilestoneNewPageQuery$data;
  variables: RepositoryMilestoneNewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPush",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RepositoryMilestoneNewPageQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW"
            },
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        "to": "RESULT"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RepositoryMilestoneNewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7f8c602e0df7c2a76a9c2f8ce24038fd",
    "metadata": {},
    "name": "RepositoryMilestoneNewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "147a55c9176ff2073a940692fd23dcb5";

export default node;
